import { Language } from "@app/provider";
import { Config } from "@app/provider/config";
import { TestType } from "@app/provider/testData/types";
import { isConnectPortal, isOncologyPortal } from "./portals";

/**
 * Resolves the external GIS scheduling link for a given product (test) type.
 *
 * Single source of truth for the product → scheduling-destination mapping used
 * by every GIS entry point (the test-result detail page's "Schedule a GIS"
 * button and the public GIS triage funnel) so a patient is always sent to the
 * same place for a given product:
 *   - Oncology products            → SCHEDULE_SESSION_ONCOLOGY
 *   - Connect (WH) products        → language-specific Acuity scheduler
 *   - Everything else (Organ Health / Renasight) → SCHEDULE_SESSION_RENASIGHT
 */
export const getGisScheduleLink = (
  testType: TestType,
  config: Config,
  currentLanguage: Language
): string => {
  if (isOncologyPortal(testType)) {
    return config.links.SCHEDULE_SESSION_ONCOLOGY;
  }
  if (isConnectPortal(testType)) {
    return currentLanguage === Language.EN
      ? `${config.links.PATIENT_PORTAL_LINK}${config.links.SCHEDULE_SESSION_EN}`
      : config.links.SCHEDULE_SESSION_ES;
  }
  return config.links.SCHEDULE_SESSION_RENASIGHT;
};
